import type { TextSize } from "InterfacesTypes/types";

const STORAGE_KEY = "text-size";

export const saveTextSize = (size: TextSize) => {
  localStorage.setItem(STORAGE_KEY, size);
};

export const loadTextSizeFromStorage = (): TextSize | null => {
  const value = localStorage.getItem(STORAGE_KEY);
  if (value === "normal" || value === "large" || value === "xLarge") {
    return value;
  }
  return null;
};
